export * from "./PressReaderConfigurationDTO";
